import { render, staticRenderFns } from "./NbNotificationBtn.vue?vue&type=template&id=7f02286a&scoped=true&"
import script from "./NbNotificationBtn.vue?vue&type=script&lang=js&"
export * from "./NbNotificationBtn.vue?vue&type=script&lang=js&"
import style0 from "./NbNotificationBtn.vue?vue&type=style&index=0&id=7f02286a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f02286a",
  null
  
)

export default component.exports